import { CERTIFICATION_ROLES, CONTENT_CREATOR_ROLES } from '@/constants/roles'

const CERTIFICATION_FEATURE_FLAG = 'certificationManagementTool'

const CONTENT_CREATOR_ROUTE_NAMES = [
  'home',
  'charts',
  'content',
  'create-course',
  'create-video',
  'create-lp',
  'create-quiz',
  'create-lab',
  'create-exercise',
  'create-iframe',
  'create-collection',
  'create-sonar',
  'edit-collection',
  'bulk-collection-upload',
  'edit-course',
  'edit-video',
  'edit-lp',
  'edit-quiz',
  'bulk-quiz-upload',
  'edit-lab',
  'edit-exercise',
  'edit-iframe',
  'edit-sonar',
  'reviews',
  'reports',
]

const CERTIFICATION_ROUTE_NAMES = [
  'certifications',
  'create-certification',
  'certification-versions',
  'certification-version-edit',
]

export const ACCESS_META_BY_ROUTE_NAME = CONTENT_CREATOR_ROUTE_NAMES.reduce(
  (acc, routeName) => ({
    ...acc,
    [routeName]: {
      requiredRoles: CONTENT_CREATOR_ROLES,
    },
  }),
  CERTIFICATION_ROUTE_NAMES.reduce(
    (acc, routeName) => ({
      ...acc,
      [routeName]: {
        featureFlag: CERTIFICATION_FEATURE_FLAG,
        requiredRoles: CERTIFICATION_ROLES,
      },
    }),
    {}
  )
)
